<nav compact tuiSubheader [style.position]="'sticky'" class="bg-white">
    <tui-breadcrumbs [itemsLimit]="10">
        <ng-container *ngFor="let item of breadcrumbs; let last = last">
          <ng-container *ngIf="last; else notLast">
            <strong *tuiItem tuiFade>
              {{ item.label }}
            </strong>
          </ng-container>
          <ng-template #notLast>
            <button
              *tuiItem
              tuiLink
              type="button"
              (click)="navigate(item.link)"
              [disabled]="!item.link"  
            >
              {{ item.label }}
            </button>
          </ng-template>
        </ng-container>
      </tui-breadcrumbs>

</nav>

<section class="mb-20">
    <div class="mt-5 relative">
        <div class="w-full bg-[#E5EDFF] h-[124px] rounded-t-xl flex items-center justify-end">
            <div class="h-[32px] w-[65px] rounded-full flex items-center justify-center mr-8" [style.background-color]="user?.active ? '#6BC68A' : '#FF6B6B'">
                <p class="text-[#FFFFFF] text-sm font-bold">
                    {{ user?.active ? 'Active' : 'Inactive' }}
                </p>
            </div>
        </div>

        <div class="w-full h-[124px] flex items-center">
            <div class="ml-64 flex items-start justify-between w-full">
                <div>
                    <p class="text-2xl font-bold m-0 text-[#000000A6]">{{user?.name}} <span class="text-[#526ED3] text-base font-medium">{{user?.refNo}}</span></p>
                    <p class="text-[#6B6D80] text-sm font-medium m-0 pt-2">Account Created on {{user?.createdAt | date: 'MMM d, y'}}</p>
                </div>

            </div>

        </div>
        <div class="w-[180px] h-[180px] rounded-full absolute top-10 left-10">
            <img class="object-cover w-full h-full rounded-full" src="{{user?.profilePic}} " alt="">

        </div>

    </div>
    <tui-tabs [(activeItemIndex)]="activeItemIndex" class="gap-5">
        <button tuiTab type="button">
            My Account
        </button>

        <button tuiTab type="button" class="flex items-center gap-1">
            Notifications
            <!-- <tui-icon *ngIf="unreadCount != 0" appearance="primary" icon="@tui.dot" size="l" tuiBadge tuiSlot="top" /> -->
        </button>
        <button tuiTab type="button">
            Security
        </button>
    </tui-tabs>

    <div class="mt-10" *ngIf="activeItemIndex === 0">
        <div class="flex">
            <div class="inline-block">
                <p class="text-base font-medium text-[#3E4A58] my-0">User Information</p>
                <p class="text-sm font-semibold text-[#949494D9] my-0">View User information</p>

            </div>
            <div class="inline-block pl-[5.5rem]">
                <div>
                    <p class="text-sm text-[#595959] font-medium my-0">Email Address</p>
                    <p class="text-[#526ED3] text-xl font-bold my-0">{{user?.email}}</p>
                </div>
                <div class="pt-5">
                    <p class="text-sm text-[#595959] font-medium my-0">Phone Number</p>
                    <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">{{user?.contactNo}}</p>
                </div>

            </div>

        </div>
        <div class="flex mt-8">
            <div class="inline-block">
                <p class="text-base font-medium text-[#3E4A58] my-0">Notes</p>
                <p class="text-sm font-semibold text-[#949494D9] my-0">View Notes</p>

            </div>
            <div class="inline-block pl-[210px] lg:pl-[210px] xl:pl-[11.4rem] 2xl:pl-[11.4rem]">
                <div style="border: 1px solid #D1D5DB; border-radius: 6px; padding: 16px;">
                    <p class="text-[0.938rem] text-[#1B1F3BA6] font-medium my-0 w-full md:w-full lg:w-full xl:w-[760px] 2xl:w-[960px] h-full">
                        {{user?.notes}}</p>
                </div>
            </div>

        </div>
    </div>
    <div class="mt-10" *ngIf="activeItemIndex === 1">
        <div class="xl:w-1/2 flex flex-col gap-3">
            <div class="group" *ngFor="let notification of notifications" tuiAppearance="floating" tuiCardLarge>
                <div class="flex flex-col gap-0 relative">
                    <div *ngIf="!notification.isOpened" class="absolute top-0 right-0">
                        <tui-badge appearance="positive" tuiStatus>
                            New
                        </tui-badge>
                    </div>
                    <p class="font-[500] text-[1rem] text-[#3E4A58] my-0">{{notification?.title}}</p>
                    <p class="font-[400] text-[0.8125rem] text-[#A4A4A4] my-0">
                        {{ notification?.createdAt | date: "d MMMM y 'at' h.mm a" }}
                    </p>

                    <p class="font-[400] text-[0.9375rem] text-[#6B6D80] my-0">{{notification?.description}}</p>
                    <div class="w-full flex-row justify-end gap-2 mt-3 hidden group-hover:flex">
                        <a [loading]="notificationLoading" appearance="outline" tuiButton type="button" size="s" href="{{notification?.link}}">
                            View Profile
                        </a>
                        <button [loading]="notificationLoading" *ngIf="!notification.isOpened" appearance="outline" tuiButton type="button" size="s" (click)="toggleOpenedStatus(notification._id)">
                            Mark as Read
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="notifications.length === 0" class="flex justify-center items-center h-[200px]">
                <p class="text-[#6B6D80] text-lg font-medium">No Notifications</p>
            </div>
            <button *ngIf="!noMoreNotifications && notifications.lenth > 0" appearance="floating" [disabled]="notificationLoading" [loading]="notificationLoading" tuiButton type="button" size="m" (click)="loadMore()">
                Load More
            </button>
        </div>
    </div>
    <div class="mt-10" *ngIf="activeItemIndex === 2">
        <form [formGroup]="changePasswordForm" (ngSubmit)="submitChangePassword()">
            <div class="flex">
                <div>
                    <p class="text-base font-medium text-[#3E4A58] my-0">User Information</p>
                    <p class="text-sm font-normal text-[#949494D9] my-0 w-[225px]">Enter supplier Information</p>
                </div>
                <div class="w-full xl:w-1/3 2xl:w-1/3 pl-[6rem]">
                    <label tuiLabel class="tui-space_bottom-4">
                        <tui-input-password formControlName="oldPassword">
                            Old Password
                            <input tuiTextfieldLegacy type="password" />
                        </tui-input-password>
                        <tui-error formControlName="oldPassword" class="mb-3" [error]="[] | tuiFieldError | async" />
                    </label>

                    <label tuiLabel class="tui-space_bottom-4">
                        <tui-input-password formControlName="password">
                            New Password
                            <input tuiTextfieldLegacy type="password" />
                        </tui-input-password>
                        <tui-error formControlName="password" class="mb-3" [error]="[] | tuiFieldError | async" />
                    </label>

                    <label tuiLabel class="tui-space_bottom-4">
                        <tui-input-password formControlName="confirmPassword">
                            Confirm Password
                            <input tuiTextfieldLegacy type="password" />
                        </tui-input-password>
                        <tui-error formControlName="confirmPassword" class="mb-3" [error]="[] | tuiFieldError | async" />
                    </label>

                    <div class="mt-5  space-x-5 flex justify-end">
                        <button tuiButton [disabled]="isLoading" [loading]="isLoading" appearance="primary" size="m" type="submit">
                            Update Password
                        </button>
                    </div>
                </div>
            </div>
           
        </form>

    </div>
</section>